import React, { useEffect, useState } from 'react';

export const HistoryContext = React.createContext();

export const HistoryProvider = ({children}) => {

    let dataState = '';
    let data = window.localStorage.getItem('url-history');
    let currentUrl = window.location.href.split("/").pop();

    if(currentUrl === '' || currentUrl === null){
      currentUrl = 'home'
    }

    if(data !== null && data !== ''){
        dataState = data;
    } else {
      dataState = 'home';
    }

    const [urlHistory,setUrlHistory] = useState(dataState);

      useEffect(() => {
        
        if(urlHistory.includes(currentUrl)){
          let index = urlHistory.indexOf(currentUrl) + currentUrl.length;
          setUrlHistory(urlHistory.substring(0,index));

        } else if(currentUrl !== 'home')
              setUrlHistory(urlHistory + ',' + currentUrl);
      }, []);

      useEffect(() => {
        window.localStorage.setItem('url-history', urlHistory);
      }, [urlHistory]); 

    return (
        <HistoryContext.Provider value={{ urlHistory, setUrlHistory }}>
                {children}
        </HistoryContext.Provider>

    )

}